import {
  ISVGAnimationsSettings,
  ISVGColorSettings,
  ISVGSettings,
  ISVGTextSettings,
  ISVGVisibilitySettings,
} from './svgChart.types'

const generateEmptySvgSettings = (): ISVGSettings => {
  return {
    title: '',
    image_id: null,
    color: [],
    movements: [],
    text: [],
    rotations: [],
    visibility: [],
  }
}

const generateColorSettingsRow = (): ISVGColorSettings => {
  return { color: '#f4af4e', condition: '=', device_id: null, node_id: null, value: 0, parameter_id: null }
}

const generateMovementSettingsRow = (): ISVGAnimationsSettings => {
  return {
    type: 'movements',
    parameter_id: null,
    value: 0,
    device_id: null,
    node_id: null,
    condition: '=',
    cycle: false,
    direction: 'left',
    distance: 0,
    duration: 3,
    hide_self: false,
    rotate_one_way: false,
  }
}

const generateRotationsSettingsRow = (): ISVGAnimationsSettings => {
  return {
    type: 'rotations',
    parameter_id: null,
    value: 0,
    device_id: null,
    node_id: null,
    condition: '=',
    cycle: false,
    direction: 'left',
    distance: 0,
    duration: 3,
    hide_self: false,
    rotate_one_way: false,
  }
}

const generateTextSettingsRow = (): ISVGTextSettings => {
  return { parameter_id: null, device_id: null, node_id: null }
}

const generateVisibilitySettingsRow = (): ISVGVisibilitySettings => {
  return { parameter_id: null, node_id: null, condition: '=', device_id: null, value: 0, action: 'hide' }
}

const generateNewSettingsLine = (lineType: 'text' | 'color' | 'visibility' | 'movements' | 'rotations') => {
  switch (lineType) {
    case 'rotations':
      return generateRotationsSettingsRow()
    case 'color':
      return generateColorSettingsRow()
    case 'movements':
      return generateMovementSettingsRow()
    case 'text':
      return generateTextSettingsRow()
    case 'visibility':
      return generateVisibilitySettingsRow()
  }
}

const svgChartGenerators = {
  generateEmptySvgSettings,
  generateColorSettingsRow,
  generateMovementSettingsRow,
  generateTextSettingsRow,
  generateVisibilitySettingsRow,
  generateRotationsSettingsRow,
  generateNewSettingsLine,
}
export default svgChartGenerators
